<mat-card class="slidecontent">
  <div class="headcontent">
    <div class="pophead">
      <h3>Create Field</h3>
  
      <mat-icon class="close" (click)="closecreateField(closeSlideValue)">close</mat-icon>
    </div>
    
  </div>
    <div class="dialog_content">

      <form class="fix-mat-form-field" [formGroup]="addCreatefieldForm">
        <div class="lblcus">
          <label >Select Field Type</label>
          <mat-radio-group aria-label="Select an option" color="primary" formControlName="fieldCategoty" (change)="onRadiobuttonChange($event)">
            <mat-radio-button value="2">Global</mat-radio-button>
            <mat-radio-button value="3">Custom</mat-radio-button>
          </mat-radio-group>
        </div>
        
        <mat-form-field class="example-full-width">
          <mat-label>Field Name</mat-label>
          <input matInput formControlName="fieldName" placeholder="Add field name" #fieldName
            value="" />
        </mat-form-field>
  
       
        <mat-form-field appearance="">
          <mat-select
            placeholder="Field Type"
            (selectionChange)="displayFieldOnFieldTypeSelection($event)"
            [(ngModel)]="typeSelected"
            name="typeSelected"
            formControlName="fieldTypeID">
            <mat-select-trigger>
              <mat-icon>{{ TextIcon }}</mat-icon> {{ TextName }}
            </mat-select-trigger>
  
            <mat-option
              *ngFor="let fieldType of fieldTypeList"
              [value]="fieldType.fieldTypeID">
              <mat-icon>{{ fieldType.icon }}</mat-icon>
              {{ fieldType.fieldTypeName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

  
        <div class="custom" *ngIf="showTextBoxField">
          <label>Input Type</label>
          <div class="row" *ngFor="let row of inputTypeFieldArray; let i = index">
            <div class="getvalue">

              <mat-form-field class="example-full-width">
                  <input  [(ngModel)]="row.fieldText" [ngModelOptions]="{standalone: true}" matInput
                  placeholder="Add default value" value=""/> 
              </mat-form-field>

              <mat-form-field class="example-full-width">
              <input [(ngModel)]="row.placeholder" formControlName="textboxPlaceholder" matInput
              placeholder="Add placeholder name" value="" />
            </mat-form-field>

            </div>
          </div>
        </div>

        <div class="custom" *ngIf="showImageField">
          <label>Input Type</label>
          <div class="row" *ngFor="let row of imageTypeFieldArray; let i = index">
            <div class="getvalue">
              <mat-form-field class="example-full-width">
              <input [(ngModel)]="row.altText" [ngModelOptions]="{standalone: true}" matInput
              placeholder="Add alt text" value="" />
            </mat-form-field>
            </div>
          </div>
        </div>

        <div class="custom" *ngIf="showDateField">
          <label>Input placeholder</label>
          <div class="row" *ngFor="let row of dateTypeFieldArray; let i = index">
            <div class="getvalue">
              <mat-form-field class="example-full-width">
              <input [(ngModel)]="row.dateKey"  formControlName="datePlaceholder" matInput
              placeholder="Add placeholder name" value="" />
            </mat-form-field>
            </div>
          </div>
        </div>

        <div class="custom" *ngIf="showUrlField">
          <label>Input placeholder</label>
          <div class="row" *ngFor="let row of urlTypeFieldArray; let i = index">
            <div class="getvalue">
              <mat-form-field class="example-full-width">
              <input [(ngModel)]="row.url"   matInput
              placeholder="Add placeholder name" value="" formControlName="urlPlaceholder" />
            </mat-form-field>
            </div>
          </div>
        </div>

        <div class="custom" *ngIf="showNumberField">
          <label>Input placeholder</label>
          <div class="row" *ngFor="let row of numberTypeFieldArray; let i = index">
            <div class="getvalue">
              <mat-form-field class="example-full-width">
              <input type="text" [(ngModel)]="row.number"  matInput formControlName="numberPlaceholder"
              placeholder="Add placeholder name" />
            </mat-form-field>
            </div>
          </div>
        </div>

        <div class="custom" *ngIf="showCurrencyField">
          <label>Input placeholder</label>
          <div class="row" *ngFor="let row of numberTypeFieldArray; let i = index">
            <div class="getvalue">
              <mat-form-field class="example-full-width">
              <input type="text" [(ngModel)]="row.number" formControlName="currencyPlaceholder" matInput
              placeholder="Add placeholder name" />
            </mat-form-field>
            </div>
          </div>
        </div>

        <div class="custom" *ngIf="showRadioField">
          <label>Radio Type</label>
          <div class="row" *ngFor="let row of radioFieldArray; let i = index">
           
            <div class="getvalue">
              <div appearance="legacy" fxFlex>               
  
                <mat-form-field class="example-full-width">
                  <mat-label>Option {{i+1}}</mat-label>
                  <input matInput placeholder="Add Option {{i+1}}" value="" [(ngModel)]="row.radioText"
                    [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
              </div>
            </div>
            <div class="remove" *ngIf="i > 0">
              <button mat-icon-button (click)="deleteField('r')">
                <mat-icon>remove_circle_outline</mat-icon>
              </button>
            </div>
          </div>
  
          <button mat-mini-fab color="primary" (click)="addValueFieldRadio()" class="add">
            <mat-icon>add</mat-icon>
          </button>
  
        </div>
  
        <div class="custom" *ngIf="showCheckboxField">
          <label>Checkbox Type</label>
          <div class="row" *ngFor="let row of checkBoxFieldArray; let i = index">
            <div class="symbol">
              <mat-icon>check_box_outline_blank</mat-icon>
            </div>
            <div class="getvalue">
              <div appearance="legacy" fxFlex>
               
                <mat-form-field class="example-full-width">
                  <mat-label>Option {{i+1}}</mat-label>
                  <input matInput placeholder="Add Option {{i+1}}" value="" [(ngModel)]="row.Select"
                    [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
              </div>
            </div>
            <div class="remove" *ngIf="i > 0">
              <button mat-icon-button (click)="deleteField('c')">
                <mat-icon>remove_circle_outline</mat-icon>
              </button>
            </div>
          </div>
  
          <button mat-mini-fab color="primary" (click)="addValueField()" class="add">
            <mat-icon>add</mat-icon>
          </button>
  
        </div>
  
        <div class="custom" *ngIf="showDropdownBoxField">
          <mat-form-field class="example-full-width">
          <mat-label>Add Placeholder Name</mat-label>
          <input matInput [(ngModel)]="dropDownPlace" formControlName="dropPlaceholder"  placeholder="Add Placeholder name"
            value="" />
            </mat-form-field>

          <label>Dropdown Type</label>
          <div class="row">
            <div class="getvalue">
              
              <div *ngFor="let row of dropdownFieldArray; let i = index" fxLayout="row" fxLayoutAlign="center center" >
                <mat-form-field class="example-full-width" >
                  <mat-label>Option {{i+1}} </mat-label>
                  <input matInput placeholder="Add Option {{i+1}}" value="" [(ngModel)]="row.dropdownText"
                    [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
    
                <div class="remove" *ngIf="i > 0">
                  <button mat-icon-button (click)="deleteField('d')">
                    <mat-icon>remove_circle_outline</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
  
          <button mat-mini-fab color="primary" (click)="addValueFieldropdown()" class="add">
            <mat-icon>add</mat-icon>
          </button>
  
        </div>

      
        <div class="folList" *ngIf="showFieldVategoryTypeGlobal">          
          <label>Add this field to other record types</label>       
           <div class="allfollist">
            <ng-container *ngFor="let data of fieldsList; let i=index">
              <div class="fol">
                <mat-checkbox color="primary"  [value]="data.folderID" [checked]="folderIdCheckbox.includes(data.folderID)" (change)="onCheckboxChange($event)">{{data.folderName}}</mat-checkbox> 
              </div>
            </ng-container>
          </div>

        </div>

        <div class="custom mt-10">
        <mat-form-field class="mt-10">
          <mat-select placeholder='Available On' [disabled]=true
           formControlName="availableonForms" (selectionChange)="displayCoreTypeSelection($event)">
            <!-- <mat-option value = "1"> Selected Module </mat-option> -->
            <mat-option value = "2"> Form Only </mat-option>
            <!-- <mat-option value = "3"> Both </mat-option> -->
          </mat-select>         
       
        </mat-form-field>
      </div>
        <div class="custom" *ngIf="showFieldVategoryTypecustom">
        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field>
              <mat-select multiple placeholder="{{CoreName}}"  name = "coreSelected" (selectionChange)="displayCoreTypeSelection($event)">
                  <mat-option *ngFor = "let core of coreList" 
                    [value] = "core.subFolderID">
                    {{core.folderName}}
                 </mat-option>
              </mat-select>
           </mat-form-field>
           </div>

             <!-- <div fxLayout="row" fxLayoutAlign="start start">
              <mat-form-field>
                  <mat-select multiple placeholder = "Task"   name = "TaskSelected" (selectionChange)="displayTaskTypeSelection($event)">
                      <mat-option *ngFor = "let task of taskList" 
                        [value] = "task.subFolderID">
                        {{task.folderName}}
                     </mat-option> 
                  </mat-select>
               </mat-form-field>
               </div> -->

               <div fxLayout="row" fxLayoutAlign="start start" >
                <mat-form-field>
                    <mat-select multiple placeholder="{{CompanyName}}"   name = "companySelected" (selectionChange)="displayCompanyTypeSelection($event)">
                        <mat-option *ngFor = "let company of companyList" 
                          [value] = "company.subFolderID">
                          {{company.folderName}}
                       </mat-option>
                    </mat-select>
                 </mat-form-field>
                 </div>

                 

           <div fxLayout="row" fxLayoutAlign="start start">
            <mat-form-field>
                <mat-select multiple placeholder="{{ContactName}}"   name = "contactSelected" (selectionChange)="displayContactTypeSelection($event)">
                    <mat-option *ngFor = "let contact of contactList" 
                      [value] = "contact.subFolderID">
                      {{contact.folderName}}
                   </mat-option> 
                </mat-select>
             </mat-form-field>
             </div>
        </div>




         </form>

     
    </div>
  
    <div class="actionBtn">
      <button mat-flat-button class="cancel" (click)="closecreateField(closeSlideValue)">
        Cancel
      </button>
      <button mat-flat-button class="calltoaction" [disabled]="!addCreatefieldForm.valid || folderIdCheck != true"
       (click)="addFieldValue(addCreatefieldForm.value)" type="submit" color="primary">
        Create
      </button>
    </div>
  
  </mat-card>




<div class="overlay"  (click)="closecreateField(closeSlideValue)"></div>
